/**
 * Payment-Link Link-Tester — Demo-Mechanik (Spec 501, Phase 6).
 *
 * Die „Mit Beispieldaten ausprobieren"-Demo nutzt AUSSCHLIESSLICH den offiziellen
 * Testvektor der Format-Definition (Spec §Onboarding-Schicht). Es gibt bewusst
 * KEINEN stubbed Demo-Modus mit geratenen Werten — im Teaser ist die Demo
 * deaktiviert, bis das Format (inkl. Testvektor) geliefert ist.
 */
import type { PaymentLinkFormatDefinition } from './format-definition';

/** Sind echte Demo-Daten (Testvektor) verfuegbar? Im Teaser immer `false`. */
export function hasDemoData(format: PaymentLinkFormatDefinition): boolean {
  return format.available && format.testVector !== undefined;
}
